namespace Nobox.Chat {
    export interface TagsArr {
        Counttags?: number;
        Nmtags?: string;
        Clrtags?: string;
        Id?: number;
    }
}
